/**
 * @file index.tsx
 *
 * @fileoverview Shows a desktop link for the main navigation.
 */

import React from 'react';
import { checkHiddenMenu } from '~/jobiqo/components/Header/utils';
import Link from '~/jobiqo/components/Link';
import { checkIsLandingPage } from '~/jobiqo/utils/routes';
import { MenuLinkItem } from '~/jobiqo/models/navigation';

interface FooterLinkProps {
  /**
   * The menu link to show.
   */
  link: MenuLinkItem;
  /**
   * The current pathname.
   */
  pathname: string;
}

export const FooterLink = ({ link, pathname }: FooterLinkProps) => {
  return !checkHiddenMenu(link) ? (
    link?.url?.path.substring(0, 4) !== 'http' ? (
      <Link
        {...(link.target ? { target: link.target } : null)}
        {...(link.class ? { className: link.class } : null)}
        prefetch={false}
        key={`${link.url.path}--${link.title}`}
        {...(checkIsLandingPage(link.url.path) && link.url.path !== '/'
          ? {
              href: {
                pathname: '[...router]',
                query: { router: link.url.path },
              },
              as: link.url.path,
            }
          : {
              href: link.url.path,
            })}
      >
        <span className={pathname === link.url.path ? 'is-active' : ''}>
          {link.title}
        </span>
      </Link>
    ) : (
      <a
        className={[
          link.class,
          pathname === link.url.path ? 'is-active' : '',
        ].join(' ')}
        key={`${link.url.path}--${link.title}`}
        href={link.url.path}
        {...(link.target ? { target: link.target } : null)}
      >
        {link.title}
      </a>
    )
  ) : null;
};
export default FooterLink;
